import { useCallback } from 'react';

const usePendingRequest = ({
  source,
  onUpdate,
  onError,
  timeout = 3000,
  errorTtl = 5,
}) => {
  const checkResult = useCallback(
    async (params, localErrorTtl = errorTtl) => {
      let shouldRepeat;
      let result = null;
      let error = null;
      try {
        result = await source(params);
        shouldRepeat = onUpdate(result, params);
      } catch (e) {
        error = e;
        if (localErrorTtl-- > 0) {
          shouldRepeat = onError ? onError(e) : false;
        } else {
          shouldRepeat = false;
        }
      }

      return new Promise((resolve, reject) => {
        if (shouldRepeat) {
          setTimeout(
            () =>
              checkResult(params, localErrorTtl).then(resolve).catch(reject),
            timeout
          );
        } else if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      });
    },
    [source, onUpdate, onError, timeout, errorTtl]
  );

  return checkResult;
};

export default usePendingRequest;
